import React from 'react';
import { ExperimentsStore } from '../../../stores/ExperimentsStore';
import { injectV2 } from '../../injectV2';
import { NumericPagination } from '../NumericPagination/NumericPagination';
import { Filters } from '../Filters/Filters';
import { Templates } from '../Templates/Templates';
import { Pagination } from '../Pagination/Pagination';
import { SubHeader } from '../SubHeader/SubHeader';
import { DealerBanner } from '../DealerBanner/DealerBanner';
import { FiltersNoResults } from '../FiltersNoResults/FiltersNoResults';
import { templatesPageDataHooks } from './TemplatesPage.dataHooks';
import styles from './TemplatesPage.scss';
import '../../styles/global.scss';
import { TemplatesStore } from '../../stores/TemplatesStore';

interface TemplatesPageProps {
  experimentsStore: ExperimentsStore;
  templatesStore: TemplatesStore;
  dataHook?: string;
}

const TemplatesPageCmp = (props: TemplatesPageProps) => {
  const { experimentsStore, templatesStore, dataHook } = props;
  const subTitleRef = React.useRef<HTMLDivElement>();

  const isFiltersShown = experimentsStore.is('specs.funnel.TemplatesGalleryEnableFilters', 'true');

  const isCBDBannerShown =
    experimentsStore.is('specs.funnel.CBDBannerAndSearchRedirect', 'true') &&
    templatesStore.loadedFetchParams?.subCategorySlug === 'cbd';

  return (
    <div data-hook={dataHook}>
      <SubHeader dataHook={templatesPageDataHooks.subHeader()} subTitleRef={subTitleRef} />
      {isCBDBannerShown && (
        <div className={styles.cbdBannerWrapper}>
          <DealerBanner bannerPosition="159ab22b-08e8-46fa-8d10-a9210e8d6153" />
        </div>
      )}
      {isFiltersShown && <Filters dataHook={templatesPageDataHooks.filters()} />}

      {templatesStore.isNoFiltersResult ? (
        <FiltersNoResults dataHook={templatesPageDataHooks.filtersNoResults()} />
      ) : (
        <Templates dataHook={templatesPageDataHooks.templates()} />
      )}

      {experimentsStore.templatesGalleryV2NumericPagination ? (
        <NumericPagination dataHook={templatesPageDataHooks.numericPagination()} />
      ) : (
        <Pagination dataHook={templatesPageDataHooks.pagination()} />
      )}
    </div>
  );
};

export const TemplatesPage = injectV2('experimentsStore', 'templatesStore')(TemplatesPageCmp);
